import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import ServiceOfferService from '../../../Services/ServiceOfferService';

function PdfPreviewModal({
  show, onHide, pdfBase64, filename,
}) {
  const handleDownload = () => {
    ServiceOfferService.downloadPdf({ pdf: pdfBase64, filename });
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" fullscreen="lg-down">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa fa-file-pdf me-2 text-danger" />
          PDF Preview
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0" style={{ height: '80vh' }}>
        {pdfBase64 ? (
          <iframe
            src={`data:application/pdf;base64,${pdfBase64}`}
            width="100%"
            height="100%"
            title="Service Offer PDF Preview"
            style={{ border: 'none' }}
          />
        ) : (
          <div className="d-flex justify-content-center align-items-center h-100">
            <p className="text-muted">No PDF to preview</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
        <Button variant="primary" onClick={handleDownload} disabled={!pdfBase64}>
          <i className="fa fa-download me-2" />
          Download
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PdfPreviewModal;
